import { render, staticRenderFns } from "./footerPc.vue?vue&type=template&id=628fb504&scoped=true&"
import script from "./footerPc.vue?vue&type=script&lang=js&"
export * from "./footerPc.vue?vue&type=script&lang=js&"
import style0 from "./footerPc.vue?vue&type=style&index=0&id=628fb504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fb504",
  null
  
)

export default component.exports